import {createContext} from 'react';

const ShowImageSettings = createContext({imageIndex:0, updateImageSettings:()=>{}});

export default ShowImageSettings;